import styled from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';

export const OrganizationInfoWrapper = styled.div`
    width: 100%;
    gap: ${rem(32)};
    flex-direction: column;
`;

export const OrganizationDropdownContainer = styled.div`
    gap: ${rem(24)};
`;

export const OrganizationDropdownBlock = styled.div`
    width: 100%;
`;

export const OrganizationDropdownSubBlock = styled.div`
    width: 100%;
    margin-top: ${rem(12)};
`;

export const PersonContactsContainer = styled.div`
    width: 100%;
`;
